import React, { Component } from 'react';
import _, { map } from 'lodash';
import { message, Select, Modal } from "antd";
import { MoreOutlined } from '@ant-design/icons';
import moment from "moment-timezone";
import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import AccountOverview from "./Service/AccountOverview";
import AccountDetails from "./Service/AccountDetails";
import Services from "./Service/Services";
import Proposal from "./Service/Proposal/Proposal";
// import Proposal from "./Service/Proposal";
import Invoices from "./Service/Invoices/Invoices";
import Tickets from "./Service/CustomerTickets/Tickets";
import Loader from "../../../Common/Component/Loader";
import CustomerDrawerCollapse from './CustomDrawer/CustomerDrawerCollapse';
import CustomDrawer from "./CustomDrawer/CustomDrawer";
import UploadAgreement from "./Common/UploadAgreement";
import { errorHandle } from "../../../Common/errorHandle";
import { injectInvoicesStore } from '../../../../Stores/InvoicesStore';
import axios from "../../../../Lib/axios";
import * as yup from "yup";
import { formatToCurrency } from '../../../../Tools/formatToCurrency';
const { Option } = Select;

const tabs = [
  'Account Overview',
  'Account Details',
  'Services',
  'Proposals',
  'Invoices',
  'Tickets'
];

class CustomerDetail extends Component {
  constructor(props) {
    super(props);
    const selectedTab = this.props?.history?.location?.state?.query?.selectedTab;
    this.state = {
      currentTab: selectedTab || 0,
      message_count: 0,
      customer: {},
      callLog: this.props?.CallLog?.logList || {},
      loader: false,
      accountNotes: {},
      errors: {},
      showAgreementButton: false,
      showAgreement: false,
      quoteDetail: {},
      showSidebar: true,
      addServiceClicked: false,
      serviceOrder: {},
      invoice_id: '',
      service_order_uuid: '',
      fromOverview: {is: false, to: ''},
      isExpandPanel: false,
      cancelation_reason: '',
      cancelation_details: '',
      is_reason_select: false,
      deactivateModalVisible: false
    }
  }

  rerender = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    if (id) {
      this.setState({ loader: true });
      this.props.getCommercialCustomer(id) // get customer detail
      this.props.getAllQuote({ is_looking_for_proposal: true, user__uuid: id }) // get customer detail
      this.props.getServiceOrder({user__uuid: id}) // get service order
    }
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    if (id) {
      this.setState({ loader: true });
      this.props.getCommercialCustomer(id) // get customer detail
      this.props.getAllQuote({ is_looking_for_proposal: true, user__uuid: id }) // get customer detail
      this.props.getInvoiceSummary({ user__uuid: id }) // get invoice summary
      this.props.getServiceOrder({user__uuid: id}) // get service order
    }

    let is_ticket_details = JSON.parse(localStorage.getItem('is_ticket_details')) || null;
    if (is_ticket_details) {
      if (is_ticket_details.record && is_ticket_details.record.user) {
        //Change the tab as per requirement
        this.setState({
          currentTab: 5
        })
      }
    }
    //Unread message count API
    this.props.getMessagesCount({ user__uuid: id });
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const invoiceSummary = this.props.invoice_summary;
    const { callLog, serviceOrder } = this.state;
    this.setState({ loader: false });

    ////////////////////// error handle ////////////////////////////
    if (Object.keys(nextProps?.ServiceOrder?.errors).length > 0 && nextProps?.ServiceOrder?.errors !== this.props?.ServiceOrder?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.ServiceOrder?.errors)
    }
    if (Object.keys(nextProps?.CommercialCustomer?.errors).length > 0 && nextProps?.CommercialCustomer?.errors !== this.props?.CommercialCustomer?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CommercialCustomer?.errors)
    }
    if (Object.keys(nextProps?.UpdateNotification?.errors).length > 0 && nextProps?.UpdateNotification?.errors !== this.props?.UpdateNotification?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.UpdateNotification?.errors)
    }
    if (Object.keys(nextProps?.AccountNotes?.errors).length > 0 && nextProps?.AccountNotes?.errors !== this.props?.AccountNotes?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AccountNotes?.errors)
    }
    if (Object.keys(nextProps?.CardList?.errors).length > 0 && nextProps?.CardList?.errors !== this.props?.CardList?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CardList?.errors)
    }
    if (Object.keys(nextProps?.PricingHistory?.errors).length > 0 && nextProps?.PricingHistory?.errors !== this.props?.PricingHistory?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.PricingHistory?.errors)
    }
    if (Object.keys(nextProps?.Invoice?.errors).length > 0 && nextProps?.Invoice?.errors !== this.props?.Invoice?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.Invoice?.errors)
    }
    if (Object.keys(nextProps?.AllMessages?.errors).length > 0 && nextProps?.AllMessages?.errors !== this.props?.AllMessages?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AllMessages?.errors)
    }
    if (Object.keys(nextProps?.UpdateCard?.errors).length > 0 && nextProps?.UpdateCard?.errors !== this.props?.UpdateCard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.UpdateCard?.errors)
    }
    if (Object.keys(nextProps?.AddCard?.errors).length > 0 && nextProps?.AddCard?.errors !== this.props?.AddCard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.AddCard?.errors)
    }
    if (Object.keys(nextProps?.DeleteCard?.errors).length > 0 && nextProps?.DeleteCard?.errors !== this.props?.DeleteCard?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.DeleteCard?.errors)
    }
    ////////////////////////////////////////////////
    if (Object.keys(nextProps?.CommercialProposal?.list).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.list) !== JSON.stringify(this.props?.CommercialProposal?.list)) {
      this.setState({ quoteDetail: nextProps?.CommercialProposal?.list?.results?.[0] });
    }

    // get customer detail
    if (Object.keys(nextProps?.CommercialCustomer?.getCustomer).length > 0 &&
      nextProps?.CommercialCustomer?.getCustomer !== JSON.stringify(this.props?.CommercialCustomer?.getCustomer)) {
      this.setState({ customer: nextProps?.CommercialCustomer?.getCustomer });
    }

    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0 &&
      JSON.stringify(nextProps?.CallLog?.logList) !== JSON.stringify(this.props?.CallLog?.logList)) {
      this.setState({ callLog: nextProps?.CallLog?.logList });
    }

    // add call logs
    if (Object.keys(nextProps?.CallLog?.log).length > 0 &&
      JSON.stringify(nextProps?.CallLog?.log) !== JSON.stringify(this.props?.CallLog?.log)) {
      this.setState({ callLog: { ...callLog, results: [...(callLog?.results || []), nextProps?.CallLog?.log] } });
    }

    // get unread message count
    if (Object.keys(nextProps.MessageCount.data).length > 0 && nextProps.MessageCount.data !== this.props.MessageCount.data) {
      this.setState({
        message_count: nextProps.MessageCount.data.count
      })
    }

    // Invoice summary
    if (Object.keys(nextProps?.Invoice?.invoiceSummary).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceSummary) !== JSON.stringify(invoiceSummary)) {
      this.props.SetInvoiceSummary(nextProps?.Invoice?.invoiceSummary);
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.data).length > 0 && JSON.stringify(nextProps?.ServiceOrder?.data) !== JSON.stringify(serviceOrder)) {
      this.setState({serviceOrder: nextProps?.ServiceOrder?.data?.results, loader: false});
    }

    if (Object.keys(nextProps.VoidInvoice.errors).length > 0 && nextProps.VoidInvoice.errors !== this.props.VoidInvoice.errors) {
      // display error messsage
      this.setState({ loader: false});

      if (nextProps?.VoidInvoice?.errors?.message) {
        message.error(nextProps?.VoidInvoice?.errors?.message, 10);
      }
      else {
        errorHandle(nextProps?.VoidInvoice?.errors)
      }
    }
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // show view agreement service button
  toggleServiceAgreementButton = () => {
    this.setState((prevState) => ({ showAgreementButton: !prevState.showAgreementButton }))
  }

  // show view agreement service modal
  toggleServiceAgreement = () => {
    const { showAgreement } = this.state;
    const id = this.props?.history?.location?.state?.query?.id;
    if (!showAgreement) {
      this.props.getServiceAgreement({ customer_profile__uuid: id, offset: 0, limit: 5 }) //get service agreement list
    }
    setTimeout(() => this.setState((prevState) => ({ showAgreement: !prevState.showAgreement })), 500)
  }

  toggleSidebar = (value) => {
    if (value !== this.state.showSidebar) this.setState({ showSidebar: value })
  }

  // tab change
  tabChange = (e, fromOverview = {is: false, to: ''}, isAddServiceClicked = false) => {
    this.setState({
      currentTab: e,
      fromOverview,
      addServiceClicked: isAddServiceClicked
    });
    if (e !== 3) this.setState({ showSidebar: true })
    const id = this.props?.history?.location?.state?.query?.id;
    this.props.getMessagesCount({ user__uuid: id });
    if (e !== 2) this.setState({ showAgreementButton: false })
  };

  updateSummary = (customer_id) =>
  {
    this.props.getInvoiceSummary({ user__uuid: customer_id });
  }

  // render basic detail
  renderBasicDetails = () => {
    const { customer, serviceOrder } = this.state;
    const invoiceSummary = this.props.invoice_summary;
    let a = moment(), b = this.UTCToLocal(customer?.created_at);
    const years = a.diff(b, 'year');
    b.add(years, 'years');
    const months = a.diff(b, 'months');

    const basicDetail = [
      { key: 'Account #', value: customer?.account_number },
      { key: 'Type', value: `HOA` },
      { key: 'Franchise', value: !_.isEmpty(customer?.field_office) ? `${customer?.field_office?.city}, ${customer?.field_office?.state}` : '' },
      { key: 'Joined', value: `${years}y ${months}m` },
      { key: 'Per Service Price', value: `$ ${formatToCurrency(serviceOrder?.[0]?.commercial_detail?.total) || '0.00'}`},
      { key: 'Open Balance', value: `$ ${invoiceSummary?.total_open_balance ? formatToCurrency(invoiceSummary?.total_open_balance) : '0.00'}`},
    ]

    return map(basicDetail, (item, index) =>
      <div key={`basic${index}`} className={"dcell"}>
        <span><b>{item?.key}</b></span>
        <span>{item?.value}</span>
      </div>
    );
  };

  // render tab
  renderTab = () => {
    const { currentTab, customer, quoteDetail, addServiceClicked, service_order_uuid, invoice_id, fromOverview, creditMemo_uuid } = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const hear_about_us = history?.location?.state?.query?.hear_about_us;
    const customer_satisfaction_score = history?.location?.state?.query?.customer_satisfaction_score;

    switch (currentTab) {
    case 0:
      return <AccountOverview
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        customer_satisfaction_score={customer_satisfaction_score}
        onInvoiceLineClick={(invoice_id, service_order_uuid) => {
          this.setState({invoice_id, service_order_uuid})
        }}
        onInvoicePaymentHistoryClick={(invoice_id) => {
          this.setState({invoice_id});
          this.tabChange(4, {is: true, to: "payment_history"});
        }}
        // APIs
        updateCommercialCustomer={this.props.updateCommercialCustomer}
        getCommercialCustomer={this.props.getCommercialCustomer}
        getServiceOrder={this.props.getServiceOrder}
        getAccountNotes={this.props.getAccountNotes}
        addAccountNotes={this.props.addAccountNotes}
        sendEmailReminder={this.props.sendEmailReminder}
        getCardList={this.props.getCardList}
        getInvoiceList={this.props.getInvoiceList}
        getInvoiceSummary={this.props.getInvoiceSummary}
        getAllMessages={this.props.getAllMessages}
        suspendAccount={this.props.suspendAccount}
        getLastThreePayment={this.props.getLastThreePayment}

        // Reducers
        CommercialCustomer={this.props.CommercialCustomer}
        ServiceOrder={this.props.ServiceOrder}
        AccountNotes={this.props.AccountNotes}
        EmailReminder={this.props.EmailReminder}
        CardList={this.props.CardList}
        Invoice={this.props.Invoice}
        AllMessages={this.props.AllMessages}
        LastThreePayment = {this.props.LastThreePayment}
      />
    case 1:
      return (
        <AccountDetails
          rerender={this.rerender}
          customerId={id}
          tabChange={this.tabChange}
          hearAboutUs={hear_about_us}
          outreach = {quoteDetail.outreach}
          channel_attribution={customer.channel_attribution}
          fieldOffice={this.state?.customer?.field_office_uuid}
          activateCustomer={this.activateCustomer}

          //APIs
          getCommercialCustomer={this.props.getCommercialCustomer}
          getServiceOrder={this.props.getServiceOrder}
          updateCommercialCustomer={this.props.updateCommercialCustomer}
          getCardList={this.props.getCardList}
          updateCard={this.props.updateCard}
          deleteCard={this.props.deleteCard}
          addNewCard={this.props.addNewCard}
          getBlockList={this.props.getBlockList}
          getAccountNotes={this.props.getAccountNotes}
          addAccountNotes={this.props.addAccountNotes}
          addAuthorizedUser={this.props.addAuthorizedUser}
          deleteAuthorizedUser={this.props.deleteAuthorizedUser}
          getPricingHistory={this.props.getPricingHistory}
          sendEmailReminder={this.props.sendEmailReminder}
          addGuestUser={this.props.addGuestUser}
          updateGuestUser={this.props.updateGuestUser}
          deleteGuestUser={this.props.deleteGuestUser}
          getUserList={this.props.getUserList}
          addBlockUser={this.props.addBlockUser}
          deleteBlockUser={this.props.deleteBlockUser}
          getFieldTechnicianList={this.props.getFieldTechnicianList}
          updateNotificationById={this.props.updateNotificationById}
          getNotificationById={this.props.getNotificationById}
          GoogleApi={this.props.GoogleApi}
          getGeocodeAddress={this.props.getGeocodeAddress}
          resetGeocodeAddress={this.props.resetGeocodeAddress}
          getBillingAddress={this.props.getBillingAddress}

          // Reducers
          CommercialCustomer={this.props.CommercialCustomer}
          ServiceOrder={this.props.ServiceOrder}
          UpdateCard={this.props.UpdateCard}
          DeleteCard={this.props.DeleteCard}
          AddCard={this.props.AddCard}
          BlockList={this.props.BlockList}
          AccountNotes={this.props.AccountNotes}
          CardList={this.props.CardList}
          PricingHistory={this.props.PricingHistory}
          EmailReminder={this.props.EmailReminder}
          UserList={this.props.UserList}
          FieldTechnician={this.props.FieldTechnician}
          UpdateNotification={this.props.UpdateNotification}
          NotificationList={this.props.NotificationList}
          BillingAddress={this.props.BillingAddress}
          deActivateCustomerConfirm={this.deActivateCustomerConfirm}
        />
      )

    case 2:
      return <Services
        {...this.props}
        rerender={this.rerender}
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        toggleServiceAgreementButton={this.toggleServiceAgreementButton}

        // APIs
        getServiceOrder={this.props.getServiceOrder}
        viewService={this.props.viewService}
        getPauseService={this.props.getPauseService}
        pauseService={this.props.pauseService}
        getPauseReason={this.props.getPauseReason}
        deletePauseService={this.props.deletePauseService}
        editService={this.props.editService}
        getFranchiseById={this.props.getFranchiseById}
        getServiceOrderById={this.props.getServiceOrderById}
        requestRepairService={this.props.requestRepairService}
        getServiceAgreement={this.props.getServiceAgreement}
        addServiceAgreement={this.props.addServiceAgreement}
        updateServiceLineItem={this.props.updateServiceLineItem}
        getServiceHistory={this.props.getServiceHistory}
        getGeocodeAddress={this.props.getGeocodeAddress}
        resetGeocodeAddress={this.props.resetGeocodeAddress}
        getCommercialWorkOrderList={this.props.getCommercialWorkOrderList}
        getCommercialWorkOrder={this.props.getCommercialWorkOrder}
        getFieldTechnicianFilter={this.props.getFieldTechnicianFilter}
        getFieldTechnicianList={this.props.getFieldTechnicianList}
        getWorkOrderFilter={this.props.getWorkOrderFilter}
        getServiceOrderFilter={this.props.getServiceOrderFilter}

        // Reducers
        CommercialCustomer={this.props.CommercialCustomer}
        ServiceOrder={this.props.ServiceOrder}
        Service={this.props.Service}
        GoogleApi={this.props.GoogleApi}
        CommercialWorkOrderList={this.props.CommercialWorkOrderList}
        CommercialWorkOrder={this.props.CommercialWorkOrder}
        serviceOrderFilter={this.props.ServiceOrderFilter}
        FieldTechnician={this.props.FieldTechnician}
        workOrderFilter={this.props.WorkOrderFilter}
      />
    case 3:
      return <Proposal
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        history={history}
        quoteId={quoteDetail?.uuid}
        quoteDetail={quoteDetail} // main quote detail that we select from main list
        toggleSidebar={this.toggleSidebar}
        addServiceClicked={addServiceClicked}

        // API
        getAllQuote={this.props.getAllQuote}
        getQuoteById={this.props.getQuoteById}
        addCommercialProposal={this.props.addCommercialProposal}
        addInnerCommercialProposal={this.props.addInnerCommercialProposal}
        updateInnerCommercialProposal={this.props.updateInnerCommercialProposal}
        getCommercialProposal={this.props.getCommercialProposal}
        getCommercialProposalById={this.props.getCommercialProposalById}
        patchCommercialProposal={this.props.patchCommercialProposal}
        sendProposalMail={this.props.sendProposalMail}
        getProposalPdf={this.props.getProposalPdf}
        deleteProposalLineItems={this.props.deleteProposalLineItems}
        deleteInnerProposal={this.props.deleteInnerProposal}
        getBDA={this.props.getBDA}
        editFieldOffice = {this.props.editFieldOffice}

        // Reducers
        CommercialProposal={this.props.CommercialProposal}
        EditFieldOffice = {this.props.EditFieldOffice}
      />
    case 4:
      return <Invoices
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        invoice_id={invoice_id}
        service_order_uuid={service_order_uuid}
        fromOverview={fromOverview}
        creditMemo_uuid={creditMemo_uuid}
        updateSummary={this.updateSummary}

        // APIs
        getInvoiceList={this.props.getInvoiceList}
        getInvoiceCreditMemoList={this.props.getInvoiceCreditMemoList}
        addPaymentLog={this.props.addPaymentLog}
        addManualPaymentLog={this.props.addManualPaymentLog}
        deletePaymentLog={this.props.deletePaymentLog}
        postPaymentLog={this.props.postPaymentLog}
        getCustomers={this.props.getCustomers}
        getServiceOrderNumberList={this.props.getServiceOrderNumberList}
        addInvoice={this.props.addInvoice}
        editInvoice={this.props.editInvoice}
        voidInvoice={this.props.voidInvoice}
        deleteInvoice={this.props.deleteInvoice}
        getInvoiceById={this.props.getInvoiceById}
        getServiceOrderById={this.props.getServiceOrderById}
        addInvoiceLineItem={this.props.addInvoiceLineItem}
        editInvoiceLineItem={this.props.editInvoiceLineItem}
        deleteInvoiceLineItem={this.props.deleteInvoiceLineItem}
        getInvoiceSummary={this.props.getInvoiceSummary}
        resendInvoice={this.props.resendInvoice}
        printInvoices={this.props.printInvoices}
        exportPDFStatement={this.props.exportPDFStatement}
        getAccountListing={this.props.getAccountListing}
        getPaymentHistory={this.props.getPaymentHistory}
        finalizeInvoice={this.props.finalizeInvoice}
        getCardList={this.props.getCardList}
        addNewCard={this.props.addNewCard}
        getStaffUsers={this.props.getStaffUsers}
        getInvoiceDescription={this.props.getInvoiceDescription}
        refundPayment={this.props.refundPayment}
        getSalesTax={this.props.getSalesTax}
        getCommercialWorkOrder={this.props.getCommercialWorkOrder}
        addManualInvoice={this.props.addManualInvoice}
        getWorkOrderList={this.props.getWorkOrderList}
        getWorkOrderDetail={this.props.getWorkOrderDetail}
        getCreditMemoDetails={this.props.getCreditMemoDetails}
        getWorkOrderTypeDescription={this.props.getWorkOrderTypeDescription}
        addCreditMemo={this.props.addCreditMemo}
        addCreditMemoLineItem={this.props.addCreditMemoLineItem}
        getCustomerDetail={this.props.getCustomerDetail}
        addUnattachedPayment={this.props.addUnattachedPayment}
        cleanPaymentResponse={this.props.cleanPaymentResponse}
        cleanPrePaymentResponse={this.props.cleanPrePaymentResponse}
        deleteAccountInvoice={this.props.deleteAccountInvoice}
        invoiceProcess={this.props.invoiceProcess}
        remainingCreditBalance={this.props.remainingCreditBalance}

        // Reducers
        Invoice={this.props.Invoice}
        InvoiceCreditMemoList={this.props.InvoiceCreditMemoList}
        VoidInvoice={this.props.VoidInvoice}
        CustomerList={this.props.CustomerList}
        ServiceOrder={this.props.ServiceOrder}
        PDFExportStatement={this.props.PDFExportStatement}
        GetAccountList={this.props.GetAccountList}
        PaymentHistory={this.props.PaymentHistory}
        cardList={this.props.CardList}
        addCard={this.props.AddCard}
        GetManualy={this.props.GetManualy}
        InvoiceDescription={this.props.InvoiceDescription}
        CommercialWorkOrder={this.props.CommercialWorkOrder}
        workOrderList={this.props.WorkOrderList}
        WorkOrderDetail={this.props.WorkOrderDetail}
        WorkOrderTypeDescription={this.props.WorkOrderTypeDescription}
        PostPaymentLog={this.props.PostPaymentLog}
        DeleteInvoice={this.props.DeleteInvoice}
        InvoiceProcess={this.props.InvoiceProcess}
        {...this.props}
      />
    case 5:
      return <Tickets
        //API
        getAllMessages={this.props.getAllMessages}
        getUserList={this.props.getUserList}
        getGroupList={this.props.getGroupList}
        createNewTickets={this.props.createNewTickets}
        MessageReplies={this.props.MessageReplies}
        UpdateTickets={this.props.UpdateTickets}
        readTickets={this.props.readTickets}
        getReasons={this.props.getReasons}

        // Reducers
        AllMessages={this.props.AllMessages}
        UserList={this.props.UserList}
        getCSVData={this.props.getCSVData}
        GroupList={this.props.GroupList}
        NewTicket={this.props.NewTicket}
        RepliesonTicket={this.props.RepliesonTicket}
        UpdateMesssage={this.props.UpdateMesssage}
        customerId={id}
        CommercialCustomer={this.props.CommercialCustomer}
        getReasonList={this.props.getReasonList}
        // nextProps?.CommercialCustomer?.getCustomer
      />
    default:
      return <AccountOverview
        getAccountInfo={this.props.getAccountInfo} />
    }
  }

  deActivateCustomerConfirm = () => {
    this.setState({
      deactivateModalVisible: true
    })
  }

  deactivateCustomer = () => {
    const { cancelation_reason, cancelation_details, is_reason_select } = this.state;
    const schema = yup.object().shape({
      is_reason_select: yup.bool(),
      cancelation_reason: yup.string().required("Please select a reason."),
      ...(is_reason_select ? {cancelation_details: yup.string().required("Please provide a reason.")} : null),
    });
    const data = { cancelation_reason, cancelation_details, is_reason_select };
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({deactivateModalVisible:false});
      this.setState({ is_reason_select: false, errors: {} });
      const customerId = this.props?.history?.location?.state?.query?.id;
      axios.patch(`crm/commerical-customer/${customerId}/`, {is_active: false, cancelation_reason: cancelation_reason, cancelation_details: cancelation_details,email:this.state?.customer?.email}).then((response) => {
        message.success(`Customer deactivated successfully.`, 10);
        setTimeout(() => {
          this.props.history.goBack();
        }, 1100);
      }).catch(error => {
        message.error(`Error occurred while deactivating customer.`, 10);
      });
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => {
        err_data[item.path] = item.message;
      });
      console.warn('err_data', err_data)
      this.setState({ errors: err_data, is_reason_select: false });
    });
  }

  activateCustomer = () => {
    const customerId = this.props?.history?.location?.state?.query?.id;

    axios.patch(`crm/commerical-customer/${customerId}/`, {is_active: true,email:this.state?.customer?.email}).then((response) => {
      message.success(`Customer activated successfully.`, 10);
      setTimeout(() => {
        this.props.history.goBack();
      }, 1100);
    }).catch(error => {
      message.error(`Error occurred while activating customer.`, 10);
    });
  }

  expandCollapse = (isExpand) => {
    this.setState({
      isExpandPanel: isExpand
    })
  }

  render() {
    const { currentTab, customer, loader, message_count, showAgreementButton, showAgreement, showSidebar, isExpandPanel, deactivateModalVisible, cancelation_reason, cancelation_details, errors, is_reason_select } = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const name = customer?.first_name ? `${customer?.first_name} ${customer?.last_name}` : '';
    // const name = customer?.community_name ? customer?.community_name : '';

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder={'Acc Number , HOA , Community Manager & Phone Number'} />

          {/* Sidebar */}
          <Sidebar />

          <div className="container">
            {loader && <Loader />}
            <div className={showSidebar ? `md-container` : ''} style={{maxWidth: '80%'}}>
              <div className="filter_wrapper">
                <ul className="breadcrumb">
                  <li className={"cursor_pointer"}><span onClick={() => this.props.history.goBack()}>Customer</span></li>
                  <li><span>{name}</span></li>
                </ul>
              </div>
              <div className="residential-wrapper">
                <div className="res-head pb-0">
                  <div className="flex ai-center mb-20">
                    <div className="user-info">
                      <h3>{name}</h3>
                      <span className={`status ${(!customer?.is_active) ? "inactive" : "active"}`}>
                        {customer?.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </div>

                    <div className="user-detail">
                      {this.renderBasicDetails()}
                      {showAgreementButton ? <button key="upload" className={`btn btn-warning`} onClick={() => this.toggleServiceAgreement()}>
                        View Service Agreement</button> : ''}
                      <div className="position-relative status-dropdown">
                        <span className="status-d-arrow">
                          <MoreOutlined />
                        </span>
                        <ul className="status-dropdownmenu">
                          <li><a href="#" onClick={(e) => { e.preventDefault(); this.deActivateCustomerConfirm();}} >Deactivate</a></li>
                        </ul>
                      </div>

                      <Modal
                        visible={deactivateModalVisible}
                        okText={"Deactivate"}
                        cancelText={"Cancel"}
                        onOk={() => { this.deactivateCustomer() }}
                        onCancel={() => {
                          this.setState({deactivateModalVisible:false, cancelation_reason: '', cancelation_details: '', is_reason_select: false, errors:{} })
                        }}
                        className="delete_user_modal"
                        width={400}
                      >   
                        <h3>Deactivate Customer</h3>
                        <p>Please provide a reason for deactivating this customer.</p>
                        <React.Fragment>
                          <div className="field-group">
                            <label>Reason<sup>*</sup></label>
                            <Select
                              showSearch
                              optionFilterProp="children"
                              placeholder={"Select a reason"}
                              value={cancelation_reason || ''}
                              onChange={(e) => {
                                if (e) {
                                  if (e === "other") {
                                    this.setState({is_reason_select: true});
                                  } else {
                                    this.setState({is_reason_select: false});
                                  }
                                  this.setState({cancelation_reason: e});
                                } else {
                                  this.setState({cancelation_reason: ''});
                                }
                              }}
                            >
                              <Option value="">Select reason</Option>
                              <Option value="death_of_dog">Loss of Pet</Option>
                              <Option value="service">Service Quality</Option>
                              <Option value="moving">Moving</Option>
                              <Option value="competition">Pricing</Option>
                              <Option value="other">Other</Option>
                            </Select>
                            {errors?.['cancelation_reason'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['cancelation_reason']}</label> : ''}
                          </div>
                          {cancelation_reason === "other" && <div className="field-group">
                            <textarea
                              className="textarea-gray"
                              rows="5"
                              name="cancelation_details"
                              type="text"
                              maxLength={200}
                              placeholder={"Add cancellation details here."}
                              value={cancelation_details}
                              onChange={(e) => {
                                if (e) {
                                  this.setState({cancelation_details: e?.target?.value});
                                } else {
                                  this.setState({cancelation_details: ""});
                                }
                              }} 
                            />
                            {errors?.['cancelation_details'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['cancelation_details']}</label> : ''}
                          </div>}
                        </React.Fragment>
                      </Modal>
                    </div>
                  </div>
                  <ul className="tabs dark">
                    {
                      map(tabs, (item, index) =>
                        <li key={`tab${index}`} className={currentTab === index ? 'active' : ''} onClick={(e) => { e.preventDefault(); this.tabChange(index) }}>
                          <span className="flex ai-center">
                            {item}
                            {item.toLowerCase()?.includes('tickets') && <div className="count">{message_count}</div>}
                          </span>
                        </li>
                      )
                    }
                  </ul>
                </div>
                <div className="res-body">
                  {this.renderTab()}
                </div>
              </div>
            </div>

            {showSidebar && !isExpandPanel ? <div className="side-drawer-collapsed">
              <CustomerDrawerCollapse
                expandCollapse={this.expandCollapse}
              />
            </div> : ''}

            {showSidebar && isExpandPanel ? <div className="side-drawer rdrawer-expanded">
              <CustomDrawer
                customerId={id}
                CallLog={this.props.CallLog}
                getCallLogList={this.props.getCallLogList}
                addCallLog={this.props.addCallLog}
                updateCallLog={this.props.updateCallLog}
                getAccountNotes={this.props.getAccountNotes}
                addAccountNotes={this.props.addAccountNotes}
                AccountNotes={this.props.AccountNotes}
                RepresentativeList={this.props.RepresentativeList} // reducer
                getRepresentativeList={this.props.getRepresentativeList}
                expandCollapse={this.expandCollapse}
              />
            </div> : ''}
          </div>
        </div>
        <UploadAgreement
          visible={showAgreement}
          closeModal={() => this.toggleServiceAgreement()}
          customerId={id}
          // APIs
          getServiceAgreement={this.props.getServiceAgreement}
          addServiceAgreement={this.props.addServiceAgreement}
          deleteServiceAgreement={this.props.deleteServiceAgreement}
          // reducer
          CommercialCustomer={this.props.CommercialCustomer}
        />
      </div>
    );
  }
}

export default injectInvoicesStore()(CustomerDetail);
